import http from './public'

export default {
    // 购物车数量
    getCartItemNum: (params) => {
        return http.fetchGet('getCartItemNum', params)
    },
}